import useScribbleFetcher from '@hooks/useScribbleFetcher'
import GalleryWidgetWrapper from '@widgets/Gallery/GalleryWidget'
import { FunctionComponent } from 'react'
import { ScribbleGalleryProps } from './types'

const ScribbleGallery: FunctionComponent<ScribbleGalleryProps> = ({ url }) => {
  const { galleryId, items } = useScribbleFetcher(url)

  if (!(items?.length > 0)) {
    return <div />
  }

  return (
    <GalleryWidgetWrapper
      slides={items}
      uuid={`scribble-gallery-${galleryId}`}
    />
  )
}

export default ScribbleGallery
